import { ResearchPartnerSimple, ResearchPartner, Address, Business } from 'app/fs/res/common/model/researchPartner/researchPartner';

export class ResearchPartnerWrapperUtils {

    /**
     *  transform simple object to simple
     */
    public static transformToResearchPartnerSimple( researchPartner: ResearchPartner ): ResearchPartnerSimple {
        let researchPartnerSimple: ResearchPartnerSimple = new ResearchPartnerSimple(
            researchPartner.id,
            researchPartner.business.defaulttext,
            researchPartner.business.postAddresses,
            researchPartner.funderCategoryKdsf,
            researchPartner.doctoralCooperationTypeKdsf );
        return researchPartnerSimple;
    }

    /**
     *  transform simple object to simple
     */
    public static transformToResearchPartnerComplex( researchPartnerSimple: ResearchPartnerSimple ): ResearchPartner {
        let researchPartner: ResearchPartner = new ResearchPartner();
        researchPartner.id = researchPartnerSimple.id;
        researchPartner.business = new Business();
        researchPartner.business.defaulttext = researchPartnerSimple.defaulttext;
        researchPartner.business.postAddresses = new Array<Address>();
        researchPartner.business.postAddresses = researchPartnerSimple.postAddresses;
        researchPartner.funderCategoryKdsf = researchPartnerSimple.funderCategoryKdsf;
        researchPartner.doctoralCooperationTypeKdsf = researchPartnerSimple.doctoralCooperationTypeKdsf;
        return researchPartner;
    }
}
